import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IObjectivesData {
  objConsumption: number;
  objMargin: number;
}

@Component({
  selector: 'app-annual-sales-objectives',
  templateUrl: './annual-sales-objectives.component.html',
  styleUrls: ['./annual-sales-objectives.component.scss']
})
export class AnnualSalesObjectivesComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AnnualSalesObjectivesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IObjectivesData
  ) {}

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }
}
